// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3Ucey","fileBtn":"File_fileBtn__1Y4TU","closeBtn":"File_closeBtn__1Oz3A","fileSelected":"File_fileSelected__2wUQI","disabled":"File_disabled__aqQX3"};